<template>
  <app-content>
    <releaseNotes-view />
  </app-content>
</template>

<script>
import ReleaseNotesView from '@/domain/components/generalPanel/releaseNotes/ReleaseNotesView';

export default {
  components: {
    ReleaseNotesView,
  },
};
</script>
